import type { BetZone } from './BetZone.js';

/**
 * Compute the canvas position where the puck should sit when a given point
 * is established. Returns the top-edge midpoint of the matching place
 * zone — real craps places the puck on the digit, but our chip stacks
 * share that cell so the puck rides the row boundary instead.
 *
 * Shared between crapsBridge (live) and tutorialBridge (script-driven) so
 * the puck lands in the same spot across both flows.
 */
export function pointPos(
  point: number,
  zones: BetZone[],
): { x: number; y: number } | undefined {
  const placeZone = zones.find(
    (z) => z.def.type === 'place' && z.def.number === point,
  );
  if (!placeZone) return undefined;
  const poly = placeZone.def.polygon;
  const x0 = poly[0] ?? 0;
  const x2 = poly[2] ?? 0;
  const y0 = poly[1] ?? 0;
  return { x: (x0 + x2) / 2, y: y0 };
}
